import PadraoModel from 'src/core/model/PadraoModel.js'

export default class IcarrosCorModel extends PadraoModel {
  recurso = 'icarros/cores';
  microServico = 'automotor';
  include = null;
  searchFixo = null;
  nome = 'Cores Icarros';

  colunasGrid = [
  ];

  form = {
    id: null,
    nome: null
  };

  constructor () {
    super()
    this.formLimpo = Object.assign({}, this.form)
  }
}
